//
import Pedido from '../../shared/entity/Pedido';
import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { ActivityIndicator } from 'react-native-paper';
import pedidoApi from '../../apis/pedidoApi';
import colors from '../../colors';
import { PEDIDO_NOVO, PEDIDO_LIDO, PEDIDO_CANCELADO } from '../../shared/constants';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { useEmpresa } from '../../redux/empresa/empresaHooks';

type Props = {
  id: number;
};

const ViewStatusPedido: React.FC<Props> = (props) => {
  const { id } = props;
  const [pedido, setPedido] = useState(new Pedido());
  const [empresa] = useEmpresa();

  const getPedido = async () => {
    try {
      const novoPedido = await pedidoApi.getOne({ where: { id } });
      if (!novoPedido) {
        throw new Error('Pedido não encontrado');
      }

      setPedido(novoPedido);
      if (novoPedido.status !== PEDIDO_NOVO) {
        return;
      }

      setTimeout(() => {
        getPedido();
      }, 4000);
    } catch (err) {
      setTimeout(() => {
        getPedido();
      }, 4000);
    }
  };

  useEffect(() => {
    getPedido();
  }, []);

  switch (pedido.status) {
    case PEDIDO_NOVO:
      return (
        <View style={styles.viewDefault}>
          <Text style={styles.txt}>Seu pedido ainda não foi lido...</Text>
          <ActivityIndicator size={40} color={'#fff'} style={styles.icon} />
        </View>
      );
    case PEDIDO_LIDO:
      return (
        <View style={styles.viewAceito}>
          <Text style={styles.txt}>Seu pedido foi aceito!</Text>
          <MaterialCommunityIcons
            name="checkbox-marked-circle"
            size={40}
            color="#fff"
            style={styles.icon}
          />
          <Text style={styles.txt}>Tempo estimado de entrega: {pedido.enderecoId? empresa.tempoDelivery : empresa.tempoBalcao}min</Text>
        </View>
      );
    case PEDIDO_CANCELADO:
      return (
        <View style={styles.viewNegado}>
          <Text style={styles.txt}>Seu pedido não foi aceito :(</Text>
          <MaterialCommunityIcons name="close-circle" size={40} color="#fff" style={styles.icon} />
          {pedido.justificativaCancelamento !== '' && (
            <Text style={styles.txt}>Motivo: {pedido.justificativaCancelamento}</Text>
          )}
        </View>
      );
    default:
      return (
        <View style={styles.viewDefault}>
          <Text style={styles.txt}>Seu pedido ainda não foi lido...</Text>
          <ActivityIndicator size={40} color={'#fff'} style={styles.icon} />
        </View>
      );
  }
};

const styles = StyleSheet.create({
  viewDefault: {
    backgroundColor: colors.primary,
    flex: 1,
    padding: 20,
    alignItems: 'center',
    borderRadius: 5,
    margin: 10
  },
  viewAceito: {
    backgroundColor: colors.green,
    flex: 1,
    padding: 20,
    alignItems: 'center',
    borderRadius: 5,
    margin: 10
  },
  viewNegado: {
    backgroundColor: colors.red,
    flex: 1,
    padding: 20,
    alignItems: 'center',
    borderRadius: 5,
    margin: 10
  },
  txt: { color: '#fff', fontWeight: '700', textAlign: 'center' },
  icon: {
    margin: 5
  }
});

export default ViewStatusPedido;
